var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{}.cls-2{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 20,
    height: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,5.84c-.67,0-1.3,.26-1.78,.74-.23,.23-.42,.51-.55,.82-.13,.31-.19,.63-.19,.96,0,.67,.26,1.3,.74,1.78,.23,.23,.51,.42,.82,.55,.31,.13,.63,.19,.96,.19,.67,0,1.3-.26,1.78-.74,.48-.48,.74-1.11,.74-1.78s-.26-1.3-.74-1.78c-.48-.48-1.11-.74-1.78-.74Zm7.7-.85c-.42-.98-1.03-1.86-1.8-2.6-.77-.75-1.67-1.34-2.66-1.75-1.03-.43-2.12-.64-3.25-.64s-2.22,.22-3.25,.64c-1,.41-1.89,1-2.66,1.75-.76,.74-1.37,1.62-1.8,2.6-.44,1.01-.66,2.09-.66,3.19,0,1.59,.38,3.17,1.13,4.69,.6,1.22,1.44,2.42,2.49,3.55,1.8,1.94,3.7,3.12,4.23,3.44,.15,.09,.33,.14,.5,.14,.18,0,.35-.04,.5-.14,.54-.32,2.43-1.5,4.23-3.44,1.06-1.13,1.89-2.33,2.49-3.55,.75-1.52,1.13-3.1,1.13-4.69,0-1.11-.22-2.18-.66-3.19Zm-7.7,7.32c-2.18,0-3.96-1.77-3.96-3.96s1.77-3.96,3.96-3.96,3.96,1.77,3.96,3.96-1.77,3.96-3.96,3.96Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.f3c59eefaac8004acf626404b51f2a5c.svg";
export { ForwardRef as ReactComponent };